import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Section9B from "./Section9B";
import { BsFillExclamationDiamondFill } from "react-icons/bs";

const Section9A = () => {
  return (
    <Box>
      {/* Main Heading */}
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack
          sx={{
            // width: { xl: "72%", lg: "73%", md: "88%" },
            width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
            // border: "1px solid red",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Stack
            sx={{
              fontFamily: "'Roboto', sans-serif",
              fontSize: {
                xs: "24px",
                sm: "30px",
                md: "28px",
                lg: "40px",
                xl: "40px",
              },
              lineHeight: {
                xs: "28px",
                sm: "36px",
                md: "32px",
                lg: "48px",
                xl: "48px",
              },
              fontWeight: 600,
              color: "rgb(5 78 146)",
              textAlign: "center",
              marginBottom: {
                xs: "20px",
                sm: "20px",
                md: "20px",
                lg: "20px",
                xl: "20px",
              },
              marginTop: {
                xs: "20px",
                sm: "20px",
                md: "20px",
                lg: "20px",
                xl: "20px",
              },
              // border: "1px solid red",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "6px", lg: "6px", xs: "4px" },
                  // height: { xl: "100%", lg: "100%", xs: "100%" },
                  height: {
                    xs: "20px",
                    sm: "44px",
                    md: "28px",
                    lg: "40px",
                    xl: "40px",
                  },
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  border: "1px solid rgb(5 78 146)",
                  // backgroundColor: "rgb(5 78 146)",
                  backgroundColor: "rgb(5 78 146)",
                  marginRight: {
                    xs: "8px",
                    sm: "8px",
                    md: "12px",
                    lg: "12px",
                    xl: "12px",
                  },
                  borderTopRightRadius: "8px", // Adjust the value as needed
                  borderBottomRightRadius: "8px", // Adjust the value as needed
                }}
              >
                <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
              </Stack>
            </Stack>
            <span style={{ display: "inline-flex", alignItems: "center" }}>
              Backed By
            </span>
          </Stack>
        </Stack>
      </Stack>

      <Section9B />
    </Box>
  );
};

export default Section9A;
